<ng-container *ngIf="render && matchesFilter">
  <hr *ngIf="withHr" class="my-0">
  <div class="row">
    <div class="col-12 d-flex my-3 flex-row justify-content-between align-items-center"
      [ngClass]="{ 'mt-3': titleLevel <= 7, 'disabled-control': disabled }"
      style="gap: 17px;"
    >
      <div class="apartado-item-head-opt">
        <span [ngClass]="'title-level-' + titleLevel" class="gl-text-primary d-flex flex-row justify-content-start align-items-center gap-3">
          <ng-container *ngIf="sectionReturn">
            <button
              type="button"
              class="p-button p-button-text p-1 p-button-rounded p-button-plain"
              (click)="onBackClick()"
            >
              <i class="pi pi-arrow-left"></i>
            </button>
          </ng-container>
          {{ title }}
        </span>
        <p
          class="gl-text-secondary"
          [ngStyle]="{ 'max-width': withAll ? '100%' : '500px' }"
        >
          {{ description }}
        </p>
      </div>

      <div class="d-flex flex-row justify-content-center align-items-center" style="gap: 1rem;"
        [class.disabled-control]="disabled">
        <ng-content></ng-content>
      </div>
    </div>

    <ng-content select="[body]"></ng-content>
  </div>

</ng-container>
